<template>
  <div class="block">
    <div
      class="container container-cust"
      v-for="group in groups"
      :key="group.key"
    >
      <div class="title title-cust">{{ group.title }}</div>
      <div class="entitle entitle-cust">
        {{ group.entitle }}
      </div>

      <!--  -->
      <div class="row card" v-for="item in group.rows" :key="item.key">
        <div class="col-xs-12 col-sm-6">
          <div class="card-t">
            {{ item.title }}
          </div>
          <div class="card-c">
            {{ item.text }}
          </div>
          <div class="card-c" v-show="item.text2">
            {{ item.text2 }}
          </div>
        </div>
        <div class="col-xs-12 col-sm-6">
          <img :src="item.img" class="img-responsive" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import p2 from "@/assets/images/scene/p2.png";
import p3 from "@/assets/images/scene/p3.png";
import p4 from "@/assets/images/scene/p4.png";

import p5 from "@/assets/images/scene/p5.png";
import p6 from "@/assets/images/scene/p6.png";
import p7 from "@/assets/images/scene/p7.png";

import p8 from "@/assets/images/scene/p8.png";
import p9 from "@/assets/images/scene/p9.png";
import p10 from "@/assets/images/scene/p10.png";

import p11 from "@/assets/images/scene/p11.png";
import p12 from "@/assets/images/scene/p12.png";
import p13 from "@/assets/images/scene/p13.png";

const groups = [
  {
    key: 1,
    title: "范本在线，解决范本管控的所有痛点",
    entitle: "The template is online to solve all the pain points of template",
    rows: [
      {
        key: 1,
        img: p2,
        title: "在线范本库，实时更新，实时最新",
        text: "版本管理，追踪检查对比；在途（草拟、审批中）合同范本版本更细腻提醒；公用条款、附件集中管理，一键更新；权限控制，限制乱用和指定使用。",
      },
      {
        key: 2,
        img: p3,
        title: "范本解析，将限制编辑自动解析成表单输入，关键 内容自动填入",
        text: "版本管理，追踪检查对比；在途（草拟、审批中）合同范本版本更细腻提醒；公用条款、附件集中管理，一键更新；权限控制，限制乱用和指定使用。",
      },
      {
        key: 3,
        img: p4,
        title: "集成三方系统，规范三方系统合同起草",
        text: "集成ERP系统（如地产明源、物业、商业），销售系统，招采系统，为这些系统在创建合同时提供范本的草拟功能，提升系统合同管理能力。",
      },
    ],
  },
  {
    key: 2,
    title: "协同在线，让草拟、审核省时高效",
    entitle: "Collaborative online, so that drafting and review are time-savi",
    rows: [
      {
        key: 1,
        img: p5,
        title: "三方协作编辑，在线编辑",
        text: "编辑、协作、合同传输、审核，留痕、全过程在线，高效且合同版本一致。 ",
      },
      {
        key: 2,
        img: p6,
        title: "合同对比，审批更高效",
        text: "◼ 修改自动分析：自动分析对方修改内容，记录每一次的修改版本。 ",
        text2:
          "◼ 合同比对：修改比对，版本间比对，合同与模板比对，将最新合同改了什么自动标记出来，只审核修改的地方，审核更高效",
      },
      {
        key: 3,
        img: p7,
        title: "信用监控，汇总信息，辅助合同高效精准审核",
        text: "整合企查查等第三方途径查询的合同签约方企业资质信息，助力合同审核，整合企业ERP、招采等系统内的历史签约履约信息、产品采购价格信息助力审核。",
      },
    ],
  },
  {
    key: 3,
    title: "构建流程闭环的合同用印过程",
    entitle: "Build a contract seal process with closed-loop process",
    rows: [
      {
        key: 1,
        img: p8,
        title: "智能用印",
        text: "合同在合同管理系统审批完成后，对接到印章管理系统，进行身份识别，开锁，完成用印。用印完成后将用印信息回传给合同管理系统，方便后续查看记录。",
      },
      {
        key: 2,
        img: p9,
        title: "线下用印",
        text: "合同在合同管理系统审批完成后，流程提交至印章部门，印章部门对纸质合同进行用印，完成进行拍照上传，更新用印记录。",
      },
      {
        key: 3,
        img: p10,
        title: "电子用印",
        text: "合同审批后，触发电子签系统进行合同用印，推送合同文件、相对方、用印印章等信息到印章系统；短信或邮件通知对方签署合同，实时反馈用印进度，用印结束，自动归档到合同系统。",
      },
    ],
  },
  {
    key: 4,
    title: "履约在线，签约后的合同过程管控",
    entitle:
      "Online contract fulfillment and contract process control after signing",
    rows: [
      {
        key: 1,
        img: p11,
        title: "合同台账：汇总合同所有相关信息，形成合同卡片",
        text: "合同台账列表会显示用户可见的所有合同列表，用户在该列表可以进行筛选操作和导出操作。",
      },
      {
        key: 2,
        img: p12,
        title:
          "合同台账列表会显示用户可见的所有合同列表，用户在该列表可以进行筛选操作和导出操作。",
        text: "合同生效之后，可在系统发起合同补充、变更、解除、结算等处理流程，通过合同变更审批流程完成对合同的变更。",
      },
      {
        key: 3,
        img: p13,
        title: "合同财务管理，业财融合，规避合同财务风险，让收款提速",
        text: "提供合同各阶段的结算功能，包括开票申请，开票退票，收票登记，收票退票，收款登记，付款申请，贯穿了整个结算周期。",
      },
    ],
  },
];
export default {
  data() {
    return {
      groups,
    };
  },
};
</script>

<style scoped>
.container-cust {
  margin-bottom: 20px;
}
.title-cust {
  color: #3975ea;
}
.entitle-cust {
  color: #b3b3b3;
  margin-bottom: 40px;
}
.card {
  box-shadow: 4px 6px 25px 8px rgba(0, 0, 0, 0.03);
  margin-bottom: 30px;
  padding: 30px;
}
.card-t {
  font-size: 26px;
  color: #3975ea;
  margin-bottom: 10px;
}
.card-t::before {
  content: "";
  display: inline-block;
  width: 2px;
  height: 20px;
  background: #f6c946;
  margin-right: 10px;
}
.card-c {
  color: #666;
  font-size: 16px;
  margin-bottom: 20px;
}

/*  */

.mb .card {
  background-color: #f4f8fd;
}
.mb .card-t {
  font-size: 17px;
}
.mb .card-c {
  font-size: 14px;
}
.mb .card-t::before {
  height: 14px;
}
</style>